export const serialNumberRegexp: RegExp = new RegExp('^(LPRG2|lprg2)0*(:[2-9][0-9]{2,}|[3-9][0-9]|2[3-9])(1[0-2]|0[1-9])(\\d{4})$');
